/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import FadeIn from "react-fade-in";
import { connect } from "react-redux";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import { loadHowToGuides } from "../../actions/howToGuidesActions";
import ActionBar from "../shared/general/ActionBar";
import FullScreenLoading from "../shared/loaders/FullScreenLoading";
import Guide from "./Guide";
import Wrapper from "./styles/how-to-guides-styles";

interface IGuideProps {
  title?: string;
  content?: string;
  id?: string;
  videoUrl?: string;
}
export interface IHowToGuidesProps {
  loadHowToGuides: () => void;
  loading: boolean;
  guides?: Array<IGuideProps>;
}

export class HowToGuides extends Component<IHowToGuidesProps, unknown> {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    loadHowToGuides: PropTypes.func.isRequired,
  };

  componentDidMount(): void {
    const { loadHowToGuides } = this.props;
    loadHowToGuides();
  }

  render(): ReactNode {
    const { loading, guides } = this.props;

    return (
      <ErrorBoundary>
        <ActionBar
          title="How To Guides"
          mobileTitle="How To Guides"
          loading={loading}
          backLink="Back"
          backLinkUrl="/employer/dashboard"
          mobileBackButton
        />
        <Wrapper>
          {loading ? (
            <FullScreenLoading />
          ) : (
            <FadeIn>
              {guides.map((guide, index) => (
                <Guide key={guide.id} {...guide} index={index} />
              ))}
            </FadeIn>
          )}
        </Wrapper>
      </ErrorBoundary>
    );
  }
}

interface IReduxState {
  howToGuides: {
    loading: boolean;
    guides: Array<IGuideProps>;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  loading: state.howToGuides.loading,
  guides: state.howToGuides.guides,
});

export default connect(mapStateToProps, { loadHowToGuides })(HowToGuides);
